import { useMutation } from 'react-query';
import { useApiDownload } from 'src/api';
import { useBuildVars } from 'src/config';
import { SearchACOPRequest } from './statusCount';

export interface DownloadAcopRequest extends SearchACOPRequest {
  TotalCount: number;
}

export function useDownloadAcopList(params: DownloadAcopRequest) {
  const buildVars = useBuildVars();
  const apiDownload = useApiDownload({ host: buildVars.VP_API_BASE });
  return useMutation(() =>
    apiDownload(
      '/system.webapi.gds/api/v1/gdsCoreApiDiscountMaintenance/GetDiscountDetails.xslx',
      params
    )
  );
}
